import { useState, useCallback } from 'react';

interface ModalConfig {
  [key: string]: boolean;
}

export const useModalManager = (initialModals: string[] = []) => {
  const [modals, setModals] = useState<ModalConfig>(() => {
    const initial: ModalConfig = {};
    initialModals.forEach(modal => {
      initial[modal] = false;
    });
    return initial;
  });

  const openModal = useCallback((modalName: string) => {
    setModals(prev => ({ ...prev, [modalName]: true }));
  }, []);

  const closeModal = useCallback((modalName: string) => {
    setModals(prev => ({ ...prev, [modalName]: false }));
  }, []);

  const closeAllModals = useCallback(() => {
    setModals(prev => {
      const newModals: ModalConfig = {};
      Object.keys(prev).forEach(key => {
        newModals[key] = false;
      });
      return newModals;
    });
  }, []);

  const isModalOpen = useCallback((modalName: string) => {
    return Boolean(modals[modalName]);
  }, [modals]);

  return {
    modals,
    openModal,
    closeModal,
    closeAllModals,
    isModalOpen,
  };
};